import './index.css';
import { ApolloProvider } from '@apollo/client/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App.tsx';
import { apolloClient } from './app/apollo/apollo.client';
import { store } from './app/store/store';

const root = document.getElementById('root');

if (!root) {
	throw new Error('Root element not found');
}

createRoot(root).render(
	<StrictMode>
		<Provider store={store}>
			<ApolloProvider client={apolloClient}>
				<App />
			</ApolloProvider>
		</Provider>
	</StrictMode>,
);
